import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import PopularAddonsConfiguration from "./popular-addons-configuration.jsx";

const PopularAddonsContent = ({ data, form, group, bundle }) => {
  const bundleProducts = bundle;
  const [showIndex, setShowIndex] = useState(4);
  const buttonRef = useRef(null);

  const handleShowMore = () => {
    setShowIndex(showIndex + 5);
    if (buttonRef) {
      const form = buttonRef.current.closest(".product-main__form");
      setTimeout(() => {
        form.scrollBy({ top: 200, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <>
      <div className={`popular-addons__wrapper`}>
        {bundleProducts?.map((product, index) => {
          if (index > showIndex) {
            return null;
          }

          return (
            <PopularAddonsConfiguration
              data={data}
              product={product}
              form={form}
              group={group}
            />
          );
        })}
      </div>
      {showIndex < bundleProducts.length - 1 && (
        <button
          type="button"
          className="popular-addons__show-more"
          onClick={handleShowMore}
          ref={buttonRef}
        >
          View More
        </button>
      )}
    </>
  );
};

export default PopularAddonsContent;
